
// https://stackoverflow.com/questions/5999998/check-if-a-variable-is-of-function-type/7356528#7356528
export const isFunction = function(valueToCheck) {
    return valueToCheck && {}.toString.call(valueToCheck) === '[object Function]';
}

export * from './translationUtility'
export * from './evt'